function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameHexGridTemplate = require('./game-hexgrid.template');

/**
 *   A Utility for making a hexagon game board, it is up to the game module to handle
 *   the logic of associating pieces with vertices or edges of hexes,
 *   but this tool facilitates the indexing system
 *
 *   Individual hexes are indexed as follows:
 *                 (1,1) (1,2) (1,3)
 *               (2,1) (2,2) (2,3) (2,4)
 *           (3,1) (3,2) (3,3) (3,4) (3,5)
 *               (4,2) (4,3) (4,4) (4,5)
 *                 (5,3) (5,4) (5,5)
 *   This way neighboring hexes differ by +/- r, +/-c, or +/- r&c
 *   Each hex has six vertices and six edges, indexed as follows:
 *           Vertices:        Edges:
 *               1            6    1
 *             6    2        5      2
 *             5    3         4    3
 *               4
 *
 *  Vertices and edges are not duplicated. 3_1_1 and 6_2_2 are the same edge, but we only store 3_1_1.
 *  GameHexGrid includes functions to resolve the indexing system.
 *  4_1_1, 2_2_1, and 6_2_2 are the same vertex, but 6_2_2 is the top reference
 *  Assigning vertices and edges moves left to right, top down.
 *  Every hexagon has visible vertices 6 and 1 and visible edges 5, 6, 1
 *         Vertex: 6 > 2 > 4
 *                 1 > 5 > 3
 **/
var GameHexGrid = /*#__PURE__*/function () {
  /*
  Todo, fix the parameterization (iff we have another hex-based game)
  */
  function GameHexGrid(app, mod) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, GameHexGrid);
    this.app = app;
    this.mod = mod;
    if (data) {
      this.height = data.height;
      this.width = data.width;
      this.hexmode = data.hexmode;
    } else {
      this.height = 5;
      this.width = 5;
      this.hexmode = [0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0]; //Defines hexagonal shape, 0s are empty placeholders to make things align properly
      this.hexes = ['1_1', '1_2', '1_3', '2_1', '2_2', '2_3', '2_4', '3_1', '3_2', '3_3', '3_4', '3_5', '4_2', '4_3', '4_4', '4_5', '5_3', '5_4', '5_5'];
    }
  }

  /**
   * Add hexGrid to DOM
   * @param app - Saito application
   * @param mod - game module
   */
  return _createClass(GameHexGrid, [{
    key: "render",
    value: function render() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!document.querySelector('#game-hexgrid')) {
        this.app.browser.addElementToSelector(GameHexGridTemplate(this.height, this.width, this.hexmode), selector);
      }
      this.attachEvents();
    }

    /**
     * No DOM-level functionality attached to hexGrid.
     * Included for consistency with other UI tools.
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      return;
    }

    /**
     *  Returns a list of edge ids adjacent to the given vertex id
     *   @param hexid is a string of the pattern X_Y_Z where X is the vertex number, Y row, Z column
     */
  }, {
    key: "edgesFromVertex",
    value: function edgesFromVertex(hexid) {
      var coord = hexid.split('_');
      var vid = parseInt(coord[0]);
      var rid = parseInt(coord[1]);
      var cid = parseInt(coord[2]);
      var edges = [];
      switch (vid) {
        case 1:
          edges.push(this.verifyEdge(1, rid, cid), this.verifyEdge(6, rid, cid), this.verifyEdge(2, rid - 1, cid - 1));
          break;
        case 2:
          edges.push(this.verifyEdge(1, rid, cid), this.verifyEdge(2, rid, cid), this.verifyEdge(3, rid - 1, cid));
          break;
        case 3:
          edges.push(this.verifyEdge(2, rid, cid), this.verifyEdge(3, rid, cid), this.verifyEdge(4, rid, cid + 1));
          break;
        case 4:
          edges.push(this.verifyEdge(3, rid, cid), this.verifyEdge(4, rid, cid), this.verifyEdge(2, rid + 1, cid));
          break;
        case 5:
          edges.push(this.verifyEdge(4, rid, cid), this.verifyEdge(5, rid, cid), this.verifyEdge(3, rid, cid - 1));
          break;
        case 6:
          edges.push(this.verifyEdge(5, rid, cid), this.verifyEdge(6, rid, cid), this.verifyEdge(4, rid - 1, cid - 1));
          break;
      }
      return edges.filter(function (edge) {
        return edge;
      });
    }

    /**
     * Returns properly formatted index for a particular edge in the hexGrid
     * @param eid - edge number
     * @param r - row of hex
     * @param c - column of hex
     */
  }, {
    key: "verifyEdge",
    value: function verifyEdge(eid, r, c) {
      //Check if there is a neighboring hexagon that would be the right name
      switch (eid) {
        case 2:
          if (this.exists(r, c + 1)) return "5_".concat(r, "_").concat(c + 1);
          break;
        case 3:
          if (this.exists(r + 1, c + 1)) return "6_".concat(r + 1, "_").concat(c + 1);
          break;
        case 4:
          if (this.exists(r + 1, c)) return "1_".concat(r + 1, "_").concat(c);
          break;
        default: /*edges 5,6,1 are the default acceptable nomenclature*/
      }
      if (!this.exists(r, c)) return false;
      return eid + '_' + r + '_' + c;
    }

    /**
     *  Returns a list of vertex ids adjacent to the given edge
     *   @param hexid is a string of the pattern X_Y_Z where X is the edge number, Y row, Z column
     */
  }, {
    key: "verticesFromEdge",
    value: function verticesFromEdge(hexid) {
      var coord = hexid.split('_');
      var eid = parseInt(coord[0]);
      var rid = parseInt(coord[1]);
      var cid = parseInt(coord[2]);
      var vertices = [];
      vertices.push(this.verifyVertex(eid, rid, cid));
      vertices.push(this.verifyVertex(eid + 1, rid, cid));
      return vertices.filter(function (vertex) {
        return vertex;
      }); //Does it need a filter?
    }

    /**
     * Treats all edges as having a direction to provide a singular vertex adjacent to any given edge
     * and finds the vertex of hexid2 (an edge) that is not shared by hexid1 (also an edge)
     * @param hexid1 -- full edge index (edge_row_column)
     * @param hexid2 -- full edge index (edge_row_column)
     *
     */
  }, {
    key: "directedEdge",
    value: function directedEdge(hexid1) {
      var hexid2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var coord = hexid1.split('_');
      var eid = parseInt(coord[0]);
      var rid = parseInt(coord[1]);
      var cid = parseInt(coord[2]);
      if (hexid2 === null) return this.verifyVertex(eid, rid, cid); //Don't remember why I wanted this

      //Otherwise
      var v1 = this.verticesFromEdge(hexid1);
      var v2 = this.verticesFromEdge(hexid2);
      var _iterator = _createForOfIteratorHelper(v2),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var vertex = _step.value;
          if (!v1.includes(vertex)) return vertex;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Returns properly formatted index for a particular vertex in the hexGrid
     * @param vid - vertex number
     * @param r - row of hex
     * @param c - column of hex
     */
  }, {
    key: "verifyVertex",
    value: function verifyVertex(vid, r, c) {
      if (vid > 6) {
        vid -= 6;
      }
      switch (vid) {
        case 2:
          if (this.exists(r, c + 1)) return "6_".concat(r, "_").concat(c + 1);
          break;
        case 4:
          if (this.exists(r + 1, c + 1)) return "6_".concat(r + 1, "_").concat(c + 1);
          if (this.exists(r + 1, c)) return "2_".concat(r + 1, "_").concat(c);
          break;
        case 5:
          if (this.exists(r + 1, c)) return "1_".concat(r + 1, "_").concat(c);
          break;
        case 3:
          if (this.exists(r + 1, c + 1)) return "1_".concat(r + 1, "_").concat(c + 1);
          if (this.exists(r, c + 1)) return "5_".concat(r, "_").concat(c + 1);
          break;
      }
      return vid + '_' + r + '_' + c;
    }

    /**
     * Returns an array of edges that are adjacent to the provided edge (share a vertex)
     * @param eid - full edge id (edge_row_column)
     */
  }, {
    key: "adjacentEdges",
    value: function adjacentEdges(eid) {
      var edges = [];
      var _iterator2 = _createForOfIteratorHelper(this.verticesFromEdge(eid)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var vertex = _step2.value;
          var _iterator3 = _createForOfIteratorHelper(this.edgesFromVertex(vertex)),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var edge = _step3.value;
              if (edge != eid) edges.push(edge);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return edges;
    }

    /**
     * Returns an array of vertices that are adjacent to the provided vertex (share an edge)
     * @param vid - full vertex id (vertex_row_column)
     */
  }, {
    key: "adjacentVertices",
    value: function adjacentVertices(vid) {
      var vertices = [];
      var _iterator4 = _createForOfIteratorHelper(this.edgesFromVertex(vid)),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var edge = _step4.value;
          var _iterator5 = _createForOfIteratorHelper(this.verticesFromEdge(edge)),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var vertex = _step5.value;
              if (vertex != vid) vertices.push(vertex);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return vertices;
    }

    /**
     * Tests whether hexGrid contains a hex in position r, c
     * @param r - row of hex to test
     * @param c - column of hex to test
     */
  }, {
    key: "exists",
    value: function exists(r, c) {
      return this.hexes.includes(r + '_' + c);
    }

    /**
     * Returns an array of hexes adjacent to a given vertex
     * @param hexid - full vertex id (vertex_row_column)
     */
  }, {
    key: "hexesFromVertex",
    value: function hexesFromVertex(hexid) {
      var coord = hexid.split('_');
      var vid = parseInt(coord[0]);
      var r = parseInt(coord[1]);
      var c = parseInt(coord[2]);
      var hexes = [r + '_' + c];
      switch (vid) {
        case 1:
          if (this.exists(r - 1, c - 1)) hexes.push("".concat(r - 1, "_").concat(c - 1));
          if (this.exists(r - 1, c)) hexes.push("".concat(r - 1, "_").concat(c));
          break;
        case 2:
          if (this.exists(r - 1, c)) hexes.push("".concat(r - 1, "_").concat(c));
          if (this.exists(r, c + 1)) hexes.push("".concat(r, "_").concat(c + 1));
          break;
        case 3:
          if (this.exists(r, c + 1)) hexes.push("".concat(r, "_").concat(c + 1));
          if (this.exists(r + 1, c + 1)) hexes.push("".concat(r + 1, "_").concat(c + 1));
          break;
        case 4:
          if (this.exists(r + 1, c + 1)) hexes.push("".concat(r + 1, "_").concat(c + 1));
          if (this.exists(r + 1, c)) hexes.push("".concat(r + 1, "_").concat(c));
          break;
        case 5:
          if (this.exists(r + 1, c)) hexes.push("".concat(r + 1, "_").concat(c));
          if (this.exists(r, c - 1)) hexes.push("".concat(r, "_").concat(c - 1));
          break;
        case 6:
          if (this.exists(r, c - 1)) hexes.push("".concat(r, "_").concat(c - 1));
          if (this.exists(r - 1, c - 1)) hexes.push("".concat(r - 1, "_").concat(c - 1));
          break;
      }
      return hexes;
    }
  }]);
}();
module.exports = GameHexGrid;